import React from "react";
import { Modal } from "bootstrap";
import { useHistory } from "react-router-dom";

export default function MemberOnlyFeatureModal({ member }) {
  let history = useHistory();

  function goToAccount() {
    const element = document.getElementById("trial-feature-modal");
    const trialFeatureModal = Modal.getOrCreateInstance(element);
    trialFeatureModal.hide();
    history.push(`/account?m=become-a-member`); //TODO: this works, but make sure the backdrop really disappear on production build
  }

  return (
    <div className="modal" id="trial-feature-modal" tabIndex={-1}>
      <div className="modal-dialog modal-dialog-centered modal-lg">
        <div className="modal-content">
          <div className="modal-header">
            <h1 className="modal-title h-alt">A paid membership is required for downloads</h1>
            <button type="button" className="btn-close btn-close-black" data-bs-dismiss="modal" aria-label="Close" />
          </div>
          <div className="modal-body">
            <p>Want a printable version? Join Meal Plan Club or Recipe Club to access downloads.</p>
          </div>
          <div className="modal-footer">
            <button type="button" className="btn btn-outline-primary" data-bs-dismiss="modal">
              Not yet
            </button>
            <button type="button" className="btn btn-secondary me-auto" onClick={goToAccount}>
              Yes, I'm ready
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
